(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breed-filter-nav"] && !Shopify.designMode) return;
  try {
    
  const initialiseBreedAlphabet = (root) => {
    if (root.dataset.breedFilterReady === 'true') return;

    const main = root.closest('main') || document.querySelector('#MainContent');
    const header = document.querySelector('.section-header');
    const alphabet = root.querySelector('.breed-filter-nav__alphabet');
    const letterButtons = Array.from(root.querySelectorAll('[data-breed-letter]'));

    if (!main || !alphabet) return;

    const cards = Array.from(main.querySelectorAll('.section-collection-list .collection-list__item'))
      .map((item) => {
        const link = item.querySelector('.card__heading a');
        return {
          item,
          title: link ? link.textContent.trim() : ''
        };
      })
      .filter((card) => card.title);

    const availableLetters = new Set(
      cards
        .map((card) => card.title.charAt(0).toLocaleUpperCase())
        .filter(Boolean)
    );

    let stickyFrame = null;
    let activeFrame = null;
    let followHeaderUntil = 0;
    let manualScrollUntil = 0;
    let manualScrollTimer = null;

    const resetLetterState = () => {
      letterButtons.forEach((button) => button.removeAttribute('aria-current'));
    };

    const keepLetterVisible = (button) => {
      const buttonRect = button.getBoundingClientRect();
      const alphabetRect = alphabet.getBoundingClientRect();

      if (buttonRect.left >= alphabetRect.left + 4 && buttonRect.right <= alphabetRect.right - 4) {
        return;
      }

      const targetLeft =
        button.offsetLeft - (alphabet.clientWidth - button.offsetWidth) / 2;

      alphabet.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
    };

    const setActiveLetter = (letter, keepVisible) => {
      const button = letterButtons.find(
        (candidate) => candidate.dataset.breedLetter === letter && !candidate.disabled
      );

      if (!button || button.getAttribute('aria-current') === 'true') return;

      resetLetterState();
      button.setAttribute('aria-current', 'true');

      if (keepVisible) {
        keepLetterVisible(button);
      }
    };

    const syncStickyOffset = (now) => {
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      root.style.setProperty('--breed-nav-top', `${headerBottom}px`);

      if (now < followHeaderUntil) {
        stickyFrame = window.requestAnimationFrame(syncStickyOffset);
      } else {
        stickyFrame = null;
      }
    };

    const queueStickyOffsetSync = () => {
      followHeaderUntil = performance.now() + 250;

      if (stickyFrame === null) {
        stickyFrame = window.requestAnimationFrame(syncStickyOffset);
      }
    };

    const updateActiveLetter = () => {
      activeFrame = null;

      if (performance.now() < manualScrollUntil || cards.length === 0) return;

      const threshold = root.getBoundingClientRect().bottom + 8;
      let currentCard = cards[cards.length - 1];

      for (const card of cards) {
        if (card.item.getBoundingClientRect().bottom > threshold) {
          currentCard = card;
          break;
        }
      }

      setActiveLetter(currentCard.title.charAt(0).toLocaleUpperCase(), true);
    };

    const queueActiveLetterUpdate = () => {
      if (activeFrame === null) {
        activeFrame = window.requestAnimationFrame(updateActiveLetter);
      }
    };

    const queueViewportSync = () => {
      queueStickyOffsetSync();
      queueActiveLetterUpdate();
    };

    letterButtons.forEach((button) => {
      const letter = button.dataset.breedLetter;

      if (!availableLetters.has(letter)) {
        button.disabled = true;
        return;
      }

      button.addEventListener('click', () => {
        manualScrollUntil = performance.now() + 900;
        setActiveLetter(letter, true);

        const target = cards.find(
          (card) => card.title.charAt(0).toLocaleUpperCase() === letter
        );

        if (target) {
          target.item.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }

        if (manualScrollTimer) {
          window.clearTimeout(manualScrollTimer);
        }

        manualScrollTimer = window.setTimeout(() => {
          manualScrollUntil = 0;
          queueActiveLetterUpdate();
        }, 950);
      });
    });

    queueViewportSync();
    window.addEventListener('scroll', queueViewportSync, { passive: true });
    window.addEventListener('resize', queueViewportSync);

    if (header) {
      const headerObserver = new MutationObserver(queueViewportSync);
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      if ('ResizeObserver' in window) {
        const headerResizeObserver = new ResizeObserver(queueViewportSync);
        headerResizeObserver.observe(header);
      }
    }

    root.dataset.breedFilterReady = 'true';
  };

  const initialiseBreedAlphabets = () => {
    document.querySelectorAll('[data-breed-filter-nav]').forEach(initialiseBreedAlphabet);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseBreedAlphabets);
  } else {
    initialiseBreedAlphabets();
  }

  document.addEventListener('shopify:section:load', initialiseBreedAlphabets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
